import React from "react";

import { host } from "../../paths";

import { StyledCard, Image, Ribbon, Infos, Name, Details } from "./styles";
import { IProps } from "./interfaces";

const GenreCard = ({ name, img, details, small }: IProps) => (
    <StyledCard>
        <Image src={img && host + "genres/" + img} className={"TransformTarget"} small={!!small} />
        <Ribbon />
        <Infos small={!!small}>
            <Name>{name}</Name>
            <Details>{details}</Details>
        </Infos>
    </StyledCard>
);

export default GenreCard;
